import { createTheme } from "@mui/material/styles";

export const SuggestedSlotsTheme = ({ palette }) =>
    createTheme({
        palette,
        components: {
            MuiTypography: {
                styleOverrides: {
                    root: {
                        fontSize: "14px",
                        lineHeight: "12px",
                        textTransform: "none !important"
                    },
                    helperText: {
                        fontSize: "0.75rem",
                        fontWeight: "normal",
                        letterSpacing: "normal",
                        color: palette.helperText.main,
                        fontStyle: "italic",
                        fontFamily: ["Roboto", "sans-serif"].join(",")
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        width: "255px",
                        height: "34px",
                        color: palette.text.main,
                        lineHeight: "normal !important",
                        borderRadius: "16px",
                        boxShadow: "none",
                        border: "none",
                        "&:hover": {
                            border: "none"
                        },
                        padding: "5px 8px"
                    },
                    outlined: {
                        backgroundColor: palette.grey.lightest,
                        "&:hover": {
                            backgroundColor: palette.primary.medium
                        }
                    },
                    contained: {
                        color: "white",
                        backgroundColor: palette.primary.main,
                        "&:hover": {
                            boxShadow: "none"
                        }
                    }
                }
            },
            MuiTooltip: {
                styleOverrides: {
                    tooltip: {
                        padding: "8px",
                        "& .MuiTooltip-arrow": {
                            marginRight: "8px"
                        }
                    }
                }
            }
        }
    });
